var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1582,
    height: 5,
    viewBox: "0 0 1582 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2.5C26.85 2.66667 53.2 2.825 79.55 2.975C316.7 4.325 553.85 5 791 5C1028.15 5 1265.3 4.325 1502.45 2.975C1528.8 2.825 1555.15 2.66667 1581.5 2.5C1555.15 2.33333 1528.8 2.175 1502.45 2.025C1265.3 0.675 1028.15 0 791 0C553.85 0 316.7 0.675 79.55 2.025C53.2 2.175 26.85 2.33333 0.5 2.5Z",
    fill: "#E3E3E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineHistory);
export default __webpack_public_path__ + "static/media/lineHistory.6ddaf1d308d93015335ceb315053f695.svg";
export { ForwardRef as ReactComponent };